import { graphql } from "@/gql";

export const createSupplierMutation = graphql(`
  mutation CreateSupplier($input: CreateSupplierInput!) {
    createSupplier(input: $input) {
      id
    }
  }
`);

export const updateSupplierMutation = graphql(`
  mutation UpdateSupplier($id: ID!, $input: UpdateSupplierInput!) {
    updateSupplier(id: $id, input: $input) {
      id
    }
  }
`);

export const deleteSupplierMutation = graphql(`
  mutation DeleteSupplier($id: ID!) {
    deleteSupplier(id: $id) {
      id
    }
  }
`);

export const archiveSupplierMutation = graphql(`
  mutation ArchiveSupplier($id: ID!) {
    archiveSupplier(id: $id) {
      id
      archived_at
    }
  }
`);

export const duplicateSupplierMutation = graphql(`
  mutation DuplicateSupplier($id: ID!, $name: String!) {
    duplicateSupplier(id: $id, name: $name)
  }
`);

export const applySupplierAgeRequirementsToVehiclesMutation = graphql(`
  mutation ApplySupplierAgeRequirementsToVehicles($supplierId: ID!) {
    applySupplierAgeRequirementsToVehicles(supplierId: $supplierId) {
      id
    }
  }
`);

export const updateSupplierTermsAndConditionsMutation = graphql(`
  mutation UpdateSupplierTermsAndConditionsAndConditionsMutation(
    $input: UpdateSupplierTermsAndConditionsInput!
  ) {
    updateSupplierTermsAndConditions(input: $input) {
      id
      relocation_type
      license_requirements
    }
  }
`);
